import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type TablePaginationType = "first" | "last" | "next" | "previous";

type LabelDisplayedRowsArgs = {
  from: number;
  to: number;
  count: number;
  page: number;
};

export const useLocalizedTablePagination = () => {
  const { t, i18n } = useTranslation();

  const numberFormatter = useMemo(
    () => new Intl.NumberFormat(i18n.resolvedLanguage || i18n.language || undefined),
    [i18n.resolvedLanguage, i18n.language],
  );

  return useMemo(
    () => ({
      labelRowsPerPage: t("common.tablePagination.rowsPerPage"),
      labelDisplayedRows: ({ from, to, count }: LabelDisplayedRowsArgs) => {
        const fromNumber = numberFormatter.format(from);
        const toNumber = numberFormatter.format(to);

        if (count === -1) {
          return t("common.tablePagination.displayedRowsMoreThan", {
            fromNumber,
            toNumber,
          });
        }

        return t("common.tablePagination.displayedRows", {
          fromNumber,
          toNumber,
          countNumber: numberFormatter.format(count),
        });
      },
      getItemAriaLabel: (type: TablePaginationType) => t(`common.tablePagination.actions.${type}`),
    }),
    [numberFormatter, t],
  );
};
